module.exports = __webpack_public_path__ + "img/infoicon.9f9efce3.svg";